__turbopack_context__.v({
  "divider": "ForAgentsMenu-module__rMWfNG__divider",
  "item": "ForAgentsMenu-module__rMWfNG__item",
  "menu": "ForAgentsMenu-module__rMWfNG__menu",
});
